import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { hideToast, selectToast } from '../../store/slices/notification.slice';
import { NotificationGroup } from '@progress/kendo-react-notification';
import Toast from './Toast';
import { useEffect, useRef } from 'react';

export function ToastContainer() {
  const toast = useAppSelector(selectToast);
  const dispatch = useAppDispatch();
  const timeoutRef = useRef<NodeJS.Timeout | null>();

  useEffect(() => {
    if (toast) {
      timeoutRef.current = null;
      timeoutRef.current = setTimeout(() => {
        dispatch(hideToast());
        timeoutRef.current = null;
      }, 5000);
    }
  }, [toast, dispatch]);

  return (
    <NotificationGroup
      style={{
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 99999,
      }}
    >
      {toast && (
        <Toast key={toast.id} onClose={() => dispatch(hideToast())} visible={true} {...toast} />
      )}
    </NotificationGroup>
  );
}
